<script>
import FormFieldCheckbox from './FormFieldCheckbox'

export default {
    extends: FormFieldCheckbox,
    computed: {
        $_inputHolderClasses() {
            return this.$_mode === 'view' ? 'form-check' : 'custom-control custom-switch'
        }
    }
}
</script>
